const currenciesCollection = [["DKK", "DKK"], ["NOK", "NOK"], ["SEK", "SEK"], ["USD", "USD"]]

export default currenciesCollection
